import { type PublicPostContentObject, createPublicPostContentObject } from 'models';
import { type UseQueryOptions, useQuery } from 'query';
import type { ApiClientResponseError, ResponseErrorDataObject } from 'common/services';
import { getPublicPost } from '../../services';
import { getPublicContentObjectDetailQueryKey } from '../keys';

export const usePublicPostQuery = (
  id: string,
  queryOptions?: Omit<
    UseQueryOptions<PublicPostContentObject, ApiClientResponseError<ResponseErrorDataObject>>,
    'queryFn' | 'queryKey'
  >,
) =>
  useQuery<PublicPostContentObject>({
    async queryFn() {
      const { data } = await getPublicPost({ routeParams: { id } });
      return createPublicPostContentObject(data);
    },
    queryKey: getPublicContentObjectDetailQueryKey({ id }),
    ...queryOptions,
  });
